import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Modal, ModalBody, CardTitle, Col, Label } from "reactstrap"
import { createClient } from "store/actions"
import { get } from "helpers/api_methods"

const CreateClientModal = ({ show, onDeleteClick, onCloseClick }) => {
  const dispatch = useDispatch()
  const [categories, setCategories] = useState([])

  useEffect(() => {
    if (show) {
      fetchCategories()
    }
  }, [show])

  const fetchCategories = async () => {
    try {
      const res = await get("/order/client-category/")
      if (Array.isArray(res)) {
        setCategories(res)
      } else if (res && res.results) {
        setCategories(res.results)
      }
    } catch (err) {
      console.error("Failed to fetch client categories", err)
    }
  }

  const handleValidSubmit = (onSubmitProps, values) => {
    const payload = {
      ...values,
      address: values.address_1 || values.address || "",
    }
    dispatch(createClient(payload))
    onCloseClick()
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5 ">
        <CardTitle className="h4 mb-4 mt-2">Create Client</CardTitle>
        <AvForm
          className="form-horizontal "
          onValidSubmit={(onSubmitProps, v) => {
            handleValidSubmit(onSubmitProps, v)
          }}
        >
          <div className="row mb-4">
            <Label
              htmlFor="horizontal-username-Input"
              className="col-sm-3 col-form-label"
            >
              Name <span className="text-danger">*</span>
            </Label>
            <Col sm={9}>
              <AvField
                id="horizontal-username-Input"
                name="name"
                type="text"
                validate={{
                  required: { value: true, errorMessage: "Please enter client name" },
                }}
              />
            </Col>
          </div>

          <div className="row mb-4">
            <Label
              htmlFor="modal-category-select"
              className="col-sm-3 col-form-label"
            >
              Category <span className="text-danger">*</span>
            </Label>
            <Col sm={9}>
              <AvField
                type="select"
                name="category"
                id="modal-category-select"
                className="form-select"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Please select a category",
                  },
                }}
              >
                <option value="">Select Category</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </AvField>
            </Col>
          </div>

          <div className="row mb-4">
            <Label
              htmlFor="modal-address1-input"
              className="col-sm-3 col-form-label"
            >
              Address 1
            </Label>
            <Col sm={9}>
              <AvField
                id="modal-address1-input"
                name="address_1"
                type="text"
                placeholder="optional"
              />
            </Col>
          </div>

          <div className="row mb-4">
            <Label
              htmlFor="modal-address2-input"
              className="col-sm-3 col-form-label"
            >
              Address 2
            </Label>
            <Col sm={9}>
              <AvField
                id="modal-address2-input"
                name="address_2"
                type="text"
                placeholder="optional"
              />
            </Col>
          </div>

          <div className="row mb-4">
            <Label
              htmlFor="modal-gst-input"
              className="col-sm-3 col-form-label"
            >
              GST Number
            </Label>
            <Col sm={9}>
              <AvField
                id="modal-gst-input"
                name="gst_number"
                type="text"
                placeholder="optional"
              />
            </Col>
          </div>

          <div className="row mb-4">
            <Label htmlFor="tel-input" className="col-sm-3 col-form-label">
              Phone
            </Label>
            <Col sm={9}>
              <AvField
                name="phone"
                className="form-control"
                id="tel-input"
                type="mobile"
                placeholder="optional"
                validate={{
                  minLength: {
                    value: 10,
                    errorMessage: "Your number must be 10 characters",
                  },
                  maxLength: {
                    value: 10,
                    errorMessage: "Your number must be 10 characters",
                  },
                }}
              />
            </Col>
          </div>

          <div className="row mb-4">
            <Label
              htmlFor="horizontal-email-Input"
              className="col-sm-3 col-form-label"
            >
              Email
            </Label>
            <Col sm={9}>
              <AvField
                id="horizontal-email-Input"
                name="email"
                className="form-control"
                type="email"
                placeholder="optional"
              />
            </Col>
          </div>

          <div className="row mb-4">
            <Label
              htmlFor="horizontal-lastname-Input"
              className="col-sm-3 col-form-label"
            >
              Description
            </Label>
            <Col sm={9}>
              <AvField
                id="horizontal-lastname-Input"
                name="description"
                type="textarea"
                placeholder="optional"
              />
            </Col>
          </div>

          <div className="row justify-content-end mb-2">
            <Col sm={6}>
              <div className="text-center mt-3">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger btn-lg ms-2"
                  onClick={onCloseClick}
                >
                  Cancel
                </button>
                <button
                  style={{ width: "50%" }}
                  type="submit"
                  className="btn btn-sm btn-success btn-lg ms-2"
                >
                  Save
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

CreateClientModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
}

export default CreateClientModal
